import React, { Component } from "react";
import { FormattedMessage } from "react-intl";

import { Select, Label, FormElement } from "../../../../components/Form";
import { ISelectEvent } from "../../../../types";


import {
    clefs,
    keys,
    scales,
    getSelectValue,
    localizeAbc,
    localizeInterval,
    i18nSolfa,
    lengthenSolfa,
} from "../../../../../common/parameters";
import { Tab, Card, StyledABCname } from "../styles";
import messages from "./messages";
import { IProps } from "./interfaces";

class Pitch extends Component<IProps> {
    changePitchClef = (e: ISelectEvent) => {
        const clef = e.target.value;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "pitch", prop: "clef", val: clef });
        post("save-meta-pitch-clef", { clef, planId: plan._id });
    };

    changePitchKey = (e: ISelectEvent) => {
        const key = e.target.value;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "pitch", prop: "key", val: key });
        post("save-meta-pitch-key", { key, planId: plan._id });
    };

    changePitchScale = (e: ISelectEvent) => {
        const scale = e.target.value;
        const { plan, setPlanMeta, post } = this.props;
        setPlanMeta({ cat: "pitch", prop: "scale", val: scale });
        post("save-meta-pitch-scale", { scale, planId: plan._id });
    };

    render() {
        const {
            plan: {
                meta: { pitch },
            },
            intl: { formatMessage, locale },
            publicView,
            user: { solfaShort = false, solfaKam = false },
        } = this.props;
        return (
            <Tab>
                {publicView && (
                    <>
                        <div>
                            {pitch.clef && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.clef} />
                                    </Label>
                                    <div>{getSelectValue(clefs(formatMessage), pitch.clef)}</div>
                                </FormElement>
                            )}
                            {pitch.key && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.key} />
                                    </Label>
                                    <div>{getSelectValue(keys, pitch.key)}</div>
                                </FormElement>
                            )}
                            {pitch.solfaNames && pitch.solfaNames.length > 0 && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.solfaNames} />
                                    </Label>
                                    <div>
                                        {pitch.solfaNames && pitch.solfaNames.length > 0
                                            ? pitch.solfaNames.map(solfaName => (
                                                <Card key={solfaName} dangerouslySetInnerHTML={{ __html: lengthenSolfa(i18nSolfa(solfaName, locale, solfaKam), locale, solfaShort) }}/>
                                            ))
                                            : formatMessage(messages.noData)}
                                    </div>
                                    <div>
                                        {pitch.ABCnames &&
                                            pitch.ABCnames.length > 0 &&
                                            pitch.ABCnames.map(ABCname => {
                                                return (
                                                    <StyledABCname key={ABCname}>
                                                        {localizeAbc(ABCname.replace(/'/g, "’"), locale)}
                                                    </StyledABCname>
                                                );
                                            })}
                                    </div>
                                </FormElement>
                            )}
                        </div>
                        <div>
                            {pitch.scale && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.scale} />
                                    </Label>
                                    <div>{getSelectValue(scales(formatMessage), pitch.scale)}</div>
                                </FormElement>
                            )}
                            {pitch.range && (
                                <FormElement>
                                    <Label>
                                        <FormattedMessage {...messages.range} />
                                    </Label>
                                    <div>
                                        {pitch.range && pitch.range.lABC ? (
                                            <span>
                                                <Card dangerouslySetInnerHTML={{ __html: lengthenSolfa(i18nSolfa(pitch.range.l.s, locale, solfaKam), locale, solfaShort) }} /> -{" "}
                                                <Card dangerouslySetInnerHTML={{ __html: lengthenSolfa(i18nSolfa(pitch.range.h.s, locale, solfaKam), locale, solfaShort) }} /> |{" "}
                                                {localizeInterval(pitch.range.interval, locale)}
                                            </span>
                                        ) : (
                                                formatMessage(messages.noData)
                                            )}
                                    </div>
                                    <div>
                                        {pitch.range && pitch.range.lABC && (
                                            <span>
                                                <StyledABCname>
                                                    {localizeAbc(pitch.range.lABC.abc.replace(/'/g, "’"), locale)}
                                                </StyledABCname>{" "}
                                                -{" "}
                                                <StyledABCname>
                                                    {localizeAbc(pitch.range.hABC.abc.replace(/'/g, "’"), locale)}
                                                </StyledABCname>
                                            </span>
                                        )}
                                    </div>
                                </FormElement>
                            )}
                            <FormElement>
                                <Label>
                                    <FormattedMessage {...messages.intervals} />
                                </Label>
                                <div>
                                    {pitch.intervals
                                        ? pitch.intervals.map(interval => {
                                            return <Card key={interval}>{localizeInterval(interval, locale)}</Card>;
                                        })
                                        : formatMessage(messages.noData)}
                                </div>
                            </FormElement>
                        </div>
                    </>
                )}

                {!publicView && (
                    <>
                        <div>
                            <Select
                                name="clef"
                                label={formatMessage(messages.clef)}
                                value={pitch.clef}
                                onChange={this.changePitchClef}
                                options={clefs(formatMessage)}
                            />
                            <Select
                                name="key"
                                label={formatMessage(messages.key)}
                                value={pitch.key}
                                onChange={this.changePitchKey}
                                options={keys}
                            />
                            <FormElement>
                                <Label>
                                    <FormattedMessage {...messages.solfaNames} />
                                </Label>
                                <div>
                                    {pitch.solfaNames && pitch.solfaNames.length > 0
                                        ? pitch.solfaNames.map(solfaName => {
                                            return <Card key={solfaName} dangerouslySetInnerHTML={{ __html: lengthenSolfa(i18nSolfa(solfaName, locale, solfaKam), locale, solfaShort) }} />;
                                        })
                                        : formatMessage(messages.noData)}
                                </div>
                                <div>
                                    {pitch.ABCnames &&
                                        pitch.ABCnames.length > 0 &&
                                        pitch.ABCnames.map(ABCname => {
                                            return (
                                                <StyledABCname key={ABCname}>
                                                    {localizeAbc(ABCname.replace(/'/g, "’"), locale)}
                                                </StyledABCname>
                                            );
                                        })}
                                </div>
                            </FormElement>
                        </div>
                        <div>
                            <Select
                                name="scale"
                                label={formatMessage(messages.scale)}
                                value={pitch.scale}
                                onChange={this.changePitchScale}
                                options={scales(formatMessage)}
                            />
                            <FormElement>
                                <Label>
                                    <FormattedMessage {...messages.range} />
                                </Label>
                                <div>
                                    {pitch.range && pitch.range.lABC ? (
                                        <span>
                                            <Card dangerouslySetInnerHTML={{ __html: i18nSolfa(pitch.range.l.s, locale, solfaKam) }} /> -{" "}
                                            <Card dangerouslySetInnerHTML={{ __html: i18nSolfa(pitch.range.h.s, locale, solfaKam) }} /> |{" "}
                                            {localizeInterval(pitch.range.interval, locale)}
                                        </span>
                                    ) : (
                                            formatMessage(messages.noData)
                                        )}
                                </div>
                                <div>
                                    {pitch.range && pitch.range.lABC && (
                                        <span>
                                            <StyledABCname>
                                                {localizeAbc(pitch.range.lABC.abc.replace(/'/g, "’"), locale)}
                                            </StyledABCname>{" "}
                                            -{" "}
                                            <StyledABCname>
                                                {localizeAbc(pitch.range.hABC.abc.replace(/'/g, "’"), locale)}
                                            </StyledABCname>
                                        </span>
                                    )}
                                </div>
                            </FormElement>
                            <FormElement>
                                <Label>
                                    <FormattedMessage {...messages.intervals} />
                                </Label>
                                <div>
                                    {pitch.intervals && pitch.intervals.length > 0
                                        ? pitch.intervals.map(interval => {
                                            return <Card key={interval}>{localizeInterval(interval, locale)}</Card>;
                                        })
                                        : formatMessage(messages.noData)}
                                </div>
                            </FormElement>
                        </div>
                    </>
                )}
            </Tab>
        );
    }
}

export default Pitch;
